import { combineReducers } from "@reduxjs/toolkit";
import app from "./app/slice";
import user from "./user/slice";
import events from "./events/slice";
import cloud from "./cloud/slice";
import subscription from "./subscription/slice";
import loading from "./loading/slice";
import notification from "./notification/slice";
import platforms from "./platforms/slice";
import preferences from "./preferences/slice";
import rollbar from "./rollbar/slice";
import promotions from "./promotions/slice";
import header from "./header/slice";
import page from "./page/slice";
import api from "./api/slice";
import modal from "./modal/slice";
import videoUploadSession from "./videoUploadSession/slice";
import downloads from "./downloads/slice";
import uploads from "./uploads/slice";
import view from "./view/slice";
import supportSystem from "./supportSystem/slice";
import resumableUploads from "./resumableUploads/slice";
import stripeConnectAccount from "./stripeConnectAccount/slice";

const rootReducer = combineReducers({
    app,
    user,
    events,
    cloud,
    subscription,
    loading,
    notification,
    platforms,
    preferences,
    rollbar,
    stripeConnectAccount,
    promotions,
    header,
    page,
    api,
    modal,
    videoUploadSession,
    resumableUploads,
    downloads,
    uploads,
    view,
    supportSystem
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
